import styled from "@emotion/styled";
export const SetupListRoot = styled.div`
  display: flex;
  justify-content: space-between;
`;
